// Prefer the secure Clipboard API, with a user-initiated fallback for embedded browsers.
export async function copyText(value) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    // Embedded contexts may deny the asynchronous API while still supporting copy.
  }

  const focused = document.activeElement;
  const selection = document.getSelection();
  const ranges = selection ? Array.from({ length: selection.rangeCount }, (_, i) => selection.getRangeAt(i).cloneRange()) : [];
  const buffer = document.createElement('textarea');
  buffer.value = value;
  buffer.readOnly = true;
  buffer.tabIndex = -1;
  buffer.setAttribute('aria-hidden', 'true');
  buffer.setAttribute('data-testid', 'clipboard-copy-buffer');
  Object.assign(buffer.style, { position: 'fixed', top: '0', left: '0', width: '1px', height: '1px', opacity: '0', fontSize: '16px', pointerEvents: 'none' });
  document.body.appendChild(buffer);
  try {
    buffer.focus({ preventScroll: true });
    buffer.select();
    buffer.setSelectionRange(0, value.length);
    return document.execCommand('copy');
  } catch {
    return false;
  } finally {
    buffer.remove();
    if (focused instanceof HTMLElement && focused.isConnected) focused.focus({ preventScroll: true });
    if (selection) {
      selection.removeAllRanges();
      ranges.forEach(range => selection.addRange(range));
    }
  }
}